enum EquipmentCostTreeNodeLabel {
	TYPE = 'TYPE',
	GROUP = 'GROUP',
	CATEGORY = 'CATEGORY',
	EQUIPMENT_COST = 'EQUIPMENT_COST'
}

export default EquipmentCostTreeNodeLabel;
